import { IUser } from "models/User";
import { DashboardPermissions } from "models/dashboard";
import { Workspace } from "models/workspace";

export const getWorkspacePermissions = (
  workspace: Workspace,
  user: Maybe<IUser>,
  isAtLeastPowerUser: boolean
): DashboardPermissions => {
  let viewable = false;
  let editable = false;
  let deletable = false;

  // Same race as getDashboardPermissions: the popout/standalone routes mount
  // before the user is hydrated, and this runs as soon as the workspace query
  // resolves. Requiring an id also stops an ownerless workspace reading as
  // owned (`undefined === undefined`).
  const isOwner = !!user?.id && workspace?.owner === user.id;

  switch (workspace?.type) {
    case "Personal":
      viewable = isOwner;
      editable = isOwner;
      deletable = editable;
      break;
    case "Shared":
      viewable = true;
      editable = isOwner || isAtLeastPowerUser;
      deletable = editable;
      break;
    case "Organization":
      viewable = true;
      editable = isAtLeastPowerUser;
      deletable = editable;
      break;
  }

  return {
    canView: viewable,
    canEdit: editable,
    canDelete: deletable
  };
};
